import { render, staticRenderFns } from "./NotificationAudit.template.vue?vue&type=template&id=59cb6e40&scoped=true&"
var script = {}
import style0 from "./NotificationAudit.template.vue?vue&type=style&index=0&id=59cb6e40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb6e40",
  null
  
)

export default component.exports